import React from "react";
import { Play } from "lucide-react";

const VideoPlayer = ({ src, poster, className = "" }) => {
  if (!src) return null;

  return (
    <div
      className={`relative overflow-hidden rounded-lg bg-black ${className}`}
    >
      <video
        src={src}
        poster={poster}
        controls
        className="w-full h-full object-contain"
        playsInline
      >
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;
